import script from "./update-trigger-selector.vue?vue&type=script&setup=true&lang=ts"
export * from "./update-trigger-selector.vue?vue&type=script&setup=true&lang=ts"

import "./update-trigger-selector.vue?vue&type=style&index=0&id=464d4e63&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-464d4e63"]])

export default __exports__